module.exports = __webpack_public_path__ + "static/media/tour-popup-fig-4.f23ce038.png";